// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__17_Po","upload":"Small_upload__2G4mZ","imageWrap":"Small_imageWrap__3sz3H","removeBtn":"Small_removeBtn__36IrD"};